import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=09809bad&scoped=true"
import script from "./auto.vue?vue&type=script&lang=js"
export * from "./auto.vue?vue&type=script&lang=js"
import style0 from "./auto.vue?vue&type=style&index=0&id=09809bad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09809bad",
  null
  
)

export default component.exports